import { transparentize } from "polished";
import styled, { css } from "styled-components";
import { colors } from "../../../../utils/colors";
import ChevronDownSvg from "./assets/chevron-down-v2.svg";

const ellipsesCss = css`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const FieldWrapper = styled.div`
    position: relative;
    display: block;
    width: 100%;
    background-color: ${colors.white};
    border-radius: 12px;
    box-shadow: 0 5px 20px ${transparentize(0.9, "black")};
    overflow: hidden;
`;

export const FieldLabel = styled.label`
    position: absolute;
    top: 12px;
    left: 16px;
    display: block;
    pointer-events: none;
    font-size: 14px;
    color: #acacac;
    font-weight: 500;
    right: 50px;

    ${ellipsesCss}
`;

export const Select = styled.select`
    display: block;
    appearance: none;
    width: 100%;
    border: 0;
    padding: 32px 50px 14px 12px;
    color: ${colors.brandDark};
    font-size: 16px;
    font-weight: 500;

    ${ellipsesCss}

    background-color: white;
    background-image: url(${ChevronDownSvg});
    background-size: 24px;
    background-position: top 22px right 16px;
    background-repeat: no-repeat;
`;
